import script from "./ReportRoomModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportRoomModal.vue?vue&type=script&lang=ts&setup=true"

import "./ReportRoomModal.vue?vue&type=style&index=0&id=b6464e16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6464e16"]])

export default __exports__